import React from 'react';
import { Box, Container, Alert } from '@mui/material';
import AIImportDialog from './AIImportDialog';
import { useExerciceAdvancedEditor } from './advanced-editor/useExerciceAdvancedEditor';
import EditorHeader from './advanced-editor/EditorHeader';
import { EditorSplitLayout, EditorLoading, EditorError } from './advanced-editor/EditorSplitLayout';

/**
 * Éditeur avancé pour les exercices avec prévisualisation mobile en temps réel
 * Layout split-screen: formulaire à gauche, preview mobile à droite
 */
const ExerciceAdvancedEditor: React.FC = () => {
  const editor = useExerciceAdvancedEditor();
  const { exercice, loading, error, saving, handleCancel, importDialogOpen, setImportDialogOpen, handleAIImport } = editor;

  if (loading) {
    return <EditorLoading />;
  }

  if (error || !exercice) {
    return <EditorError error={error} onCancel={handleCancel} />;
  }

  return (
    <Box sx={{ bgcolor: '#f5f5f5', minHeight: '100vh', py: 3 }}>
      <Container maxWidth="xl">
        {/* Header */}
        <EditorHeader editor={editor} exercice={exercice} />

        {saving && (
          <Alert severity="info" sx={{ mb: 2 }}>
            Sauvegarde en cours...
          </Alert>
        )}

        {/* Split Layout */}
        <EditorSplitLayout editor={editor} exercice={exercice} />


        {/* Dialog d'import IA */}
        <AIImportDialog
          open={importDialogOpen}
          onClose={() => setImportDialogOpen(false)}
          onImport={handleAIImport}
          currentExercice={exercice || undefined}
        />
      </Container>
    </Box>
  );
};

export default ExerciceAdvancedEditor;
